module.exports = __webpack_public_path__ + "img/no-loop.0718e507.svg";